export const infoCard = (theme) => ({
    infoCard: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        padding: theme.spacing(5, 7),
        width: "100%",
        height: "100%",
        backgroundColor: theme.customPalette.neutralGr02,
        border: `3px solid ${theme.customPalette.black}`,
    },
    number: {
        marginBottom: theme.spacing(3),
    },
    description: {
        lineHeight: 1.5,
    },
});

export const infoCards = (theme) => ({
    infoCards: {
        marginBottom: theme.spacing(5),
    },
    title: {},
    subtitle: {},
    cards: {
        marginTop: theme.spacing(7),
    },
    sliderElement: {
        maxWidth: 500,
        height: "100%",
        paddingRight: theme.spacing(1),
    },
});
